module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    class: ['reservation-modal dark-top refund-transaction-modal', {
      'refund-transaction-modal--scope': _vm.currentStep === _vm.STEP.SCOPE
    }],
    attrs: {
      "dialog": "modal-lg"
    },
    on: {
      "close": _vm.closeWindow
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Payment Refund")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "refund__steps px-4 pt-3 pb-1"
  }, _vm._l((_vm.STEPS), function(step, index) {
    return _c('div', {
      key: step.id,
      staticClass: "refund__step-group"
    }, [_c('div', {
      staticClass: "refund__step",
      class: {
        'refund__step--active': _vm.currentStep === step.id,
        'refund__step--done': _vm.currentStep > step.id
      }
    }, [_c('span', {
      staticClass: "refund__step-number"
    }, [(_vm.currentStep > step.id) ? [_vm._v("✓")] : [_vm._v(_vm._s(step.id))]], 2), _vm._v(" "), _c('span', {
      staticClass: "refund__step-label"
    }, [_vm._v(_vm._s(step.label))])]), _vm._v(" "), (index < _vm.STEPS.length - 1) ? _c('span', {
      staticClass: "refund__step-line",
      class: {
        'refund__step-line--done': _vm.currentStep > step.id
      }
    }) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.currentStep === _vm.STEP.SCOPE) ? _c('step1-scope', {
    attrs: {
      "value": _vm.selectedScope,
      "subStep": _vm.scopeSubStep,
      "payments": _vm.transactionPayments,
      "selectedPaymentId": _vm.selectedPaymentId,
      "reservation": _vm.getSelectedReservation
    },
    on: {
      "input": _vm.onScopeSelected,
      "select-payment": function($event) {
        _vm.selectedPaymentId = $event
      }
    }
  }) : _c('step2-details', {
    ref: "detailsStep",
    attrs: {
      "selected-scope": _vm.selectedScope,
      "selected-payment": _vm.selectedPayment,
      "scope-total": _vm.scopeTotal,
      "valid": _vm.detailsValid,
      "submitting": _vm.detailsSubmitting,
      "email-warning": _vm.detailsEmailWarning
    },
    on: {
      "update:valid": function($event) {
        _vm.detailsValid = $event
      },
      "update:submitting": function($event) {
        _vm.detailsSubmitting = $event
      },
      "update:emailWarning": function($event) {
        _vm.detailsEmailWarning = $event
      },
      "update:email-warning": function($event) {
        _vm.detailsEmailWarning = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "align-items-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.currentStep === _vm.STEP.DETAILS) ? _c('div', {
    staticClass: "color-6 w-100 text-align-right"
  }, [_vm._v("\n            " + _vm._s(_vm.detailsEmailWarning) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showCancel) ? _c('button', {
    staticClass: "btn cancel",
    attrs: {
      "type": "button",
      "disabled": _vm.detailsSubmitting
    },
    on: {
      "click": _vm.closeWindow
    }
  }, [_vm._v("Cancel")]) : _c('button', {
    staticClass: "btn blue ok",
    attrs: {
      "type": "button",
      "disabled": _vm.detailsSubmitting
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-left mr-1"
  }), _vm._v(" Back\n        ")]), _vm._v(" "), _c('button', {
    class: ['btn ok', _vm.currentStep === _vm.STEP.DETAILS ? 'green' : 'blue'],
    attrs: {
      "type": "button",
      "disabled": _vm.isNextDisabled
    },
    on: {
      "click": _vm.nextStep
    }
  }, [(_vm.detailsSubmitting) ? _c('loader', {
    attrs: {
      "size": "small"
    }
  }) : (_vm.currentStep === _vm.STEP.DETAILS) ? [_vm._v("Confirm")] : [_vm._v("Next "), _c('i', {
    staticClass: "fas fa-chevron-right ml-1"
  })]], 2)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6c4db663", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c4db663"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationRefundTransaction.vue
// module id = 2152
// module chunks = 0